document.addEventListener('click', (event) => {
  document.querySelectorAll('.smug-header details[open]').forEach((details) => {
    if (!details.contains(event.target) || event.target.closest('nav a')) details.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.smug-header details[open]').forEach((details) => {
    details.removeAttribute('open');
    details.querySelector('summary').focus();
  });
});
